// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LSvp","top":"styles_top__1XMnM","left":"styles_left__3lt3N","description":"styles_description__156nf"};